import { useMemo } from 'react'

import { useUser } from '@app/hooks'

import type {
  FollowUpEntry,
  UseFollowUpEntryParams,
} from './FollowUpActions/types'

export const useFollowUpEntry = ({
  conversation,
}: UseFollowUpEntryParams): FollowUpEntry | null => {
  const { currentUser } = useUser()

  return useMemo(() => {
    if (!currentUser) {
      return null
    }

    const currentParticipant = conversation.participants.find(
      (participant) => participant.userId === currentUser.id
    )

    if (!currentParticipant) {
      return null
    }

    const pendingAction = conversation.suggestedActions?.find(
      (action) =>
        action.status === 'Pending' &&
        action.toParticipantId === currentParticipant.id
    )

    if (!pendingAction) {
      return null
    }

    return {
      kind: 'followUpActions',
      creationDate: pendingAction.creationDate,
    }
  }, [conversation.participants, conversation.suggestedActions, currentUser])
}
